import { jsx as _jsx } from "react/jsx-runtime";
import "./Title.scss";
import { Card } from "react-bootstrap";
export const Title = ({ title, bold, }) => {
    return (_jsx(Card, { className: "title-component", children: bold ? (_jsx("h1", { style: { fontWeight: "bold" }, children: title })) : (_jsx("h1", { children: title })) }));
};
